
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_liz58_38",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_liz58_84",
  "badge-color-green": "awsui_badge-color-green_1yjyg_liz58_89",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_liz58_94",
  "badge-color-red": "awsui_badge-color-red_1yjyg_liz58_99",
  "badge-color-severity-critical": "awsui_badge-color-severity-critical_1yjyg_liz58_104",
  "badge-color-severity-high": "awsui_badge-color-severity-high_1yjyg_liz58_109",
  "badge-color-severity-medium": "awsui_badge-color-severity-medium_1yjyg_liz58_114",
  "badge-color-severity-low": "awsui_badge-color-severity-low_1yjyg_liz58_119",
  "badge-color-severity-neutral": "awsui_badge-color-severity-neutral_1yjyg_liz58_124"
};
  